import { render } from "./infoDialog.vue?vue&type=template&id=56e02e44"
import script from "./infoDialog.vue?vue&type=script&lang=js"
export * from "./infoDialog.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__